export const optionsFilterByLabel = ({ options, search }) => {
  const normalized = String(search || "")
    .toLowerCase()
    .trim();
  const list = Array.isArray(options) ? options.slice() : [];

  const filtered = list.filter((opt) => {
    const label = (typeof opt === "string" ? opt : opt.label) ?? "";
    return label.toString().toLowerCase().trim().includes(normalized);
  });

  filtered.sort((a, b) => {
    const valA = (typeof a === "string" ? a : a.value) ?? "";
    const valB = (typeof b === "string" ? b : b.value) ?? "";
    if (valA === "") return -1;
    if (valB === "") return 1;
    const labelA = (typeof a === "string" ? a : a.label) ?? "";
    const labelB = (typeof b === "string" ? b : b.label) ?? "";
    return labelA
      .toString()
      .localeCompare(labelB.toString(), undefined, { sensitivity: "base" });
  });

  return filtered;
};
